
import { faInfoCircle, faPenSquare, faTimesCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Box, Button, Divider, FormControlLabel, Grid, Paper, Radio, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { InputOnlyField, RadioGroup, Checkbox} from "@ngt/forms";
import { useFormState, useScopedField } from "@ngt/forms-core";
import { Dispatch, FC, Fragment, SetStateAction, useEffect } from "react";
import * as Dtos from '../../api/dtos';
import { DateTime } from "luxon";

const Days=[
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];

const Months=[
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];

const PaymentTypes=[
    "",
    "Cheque",
    "E-Transfer",
    "Card",
    "Cash",
    "Internet",
    "Money Order",
    "Invoiced",
    "Refund",
    "Credit Card - Stripe App"
];

interface IEditButtonFieldProps {
    handleRowClick: (paymentId: number) => void;
}

const EditButtonField: FC<IEditButtonFieldProps> = ({ handleRowClick }) => {
    const {
        state: { value: row },
    } = useScopedField<Dtos.Payment>("payments", {value: true});

    return (
        <Box
            sx={{
                color: 'primary',
                '&:hover': {
                    color: 'secondary'
                },
            }}
        >
            <Button onClick={() => handleRowClick(row?.id!)}>
                <FontAwesomeIcon size="2x" icon={faPenSquare} />
            </Button>
        </Box>
    );
};

function formatTime(d: string){
    if (!d) {
        return undefined;
    }

    const startTime = DateTime.fromISO(d);
    return `${startTime.toFormat('cccc d MMMM yyyy') }`;
}

const AdminPaymentTable : FC<{ setOpen: Dispatch<SetStateAction<{ index: number; isEdit: boolean; validationPass: boolean; } | undefined>>}> = ({ setOpen }) => {
    const {state: {value: payments}} = useScopedField<Dtos.Payment[]>("payments", {value: true});
    const { context: { getValue: getRegId }} = useScopedField<number>('id', {});
    const {state: {value: cost}} = useScopedField<number>("cost", {value: true});
    const {state: {value: regId}} = useScopedField<number>("id", {value: true});

    const {fields, errors, validating} = useFormState({errors: true, fields: true, validating: true})
    
    const hasErrors = fields.reduce((a, b) => {
        if(a)
            return a;
        return errors[b]?.length > 0;
    }, false);

    if(payments && payments?.length > 0){

        return(
            <TableContainer>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                    <TableRow>
                        <TableCell><b>Date</b></TableCell>
                        <TableCell align="left"><b>Amount</b></TableCell>
                        <TableCell align="left"><b>Type</b></TableCell>
                        <TableCell align="left"><b>C/MO/EFT Number</b></TableCell>
                        <TableCell align="left"><b>Bank Name</b></TableCell>
                        {/* <TableCell align="left"><b>Card</b></TableCell> */}
                        <TableCell align="left"><b>Receipt Number</b></TableCell>
                        <TableCell align="center"><b>Edit</b></TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {payments.map((payment: Dtos.Payment, index: any) => (
                        <TableRow
                        key={index}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                        <TableCell component="th" scope="row">
                            
                            {formatTime(payment.paymentDateTime!)} 
                        </TableCell>
                        <TableCell align="left">{payment.paymentType === 8 ? '-' : ''}${payment.amountPaid}</TableCell>
                        <TableCell align="left">{PaymentTypes[payment.paymentOption!]}</TableCell>
                        <TableCell align="left">{payment.cmNumber ? payment.cmNumber : "N/A"}</TableCell>
                        <TableCell align="left">{payment.bank ? payment.bank : "N/A"}</TableCell>
                        {/* <TableCell align="left">{payment.cardType ? payment.cardType : "N/A"}</TableCell> */}
                        <TableCell align="left">{payment.receiptNumber}</TableCell>
                        <TableCell align="center"><EditButtonField handleRowClick={() => setOpen({ index, isEdit: true, validationPass: !hasErrors && (regId !== null && regId !== undefined) })} /></TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
                {
                    hasErrors && (<Alert
                        severity="info"
                        sx={{
                            alignItems: 'center'
                        }}
                    >
                        Please fix registration errors before adding additional payment
                    </Alert>)
                }
            </TableContainer>
        );

    }

    return (
        <>
            {
                (cost !== null && cost !== undefined && cost > 0) ? (
                    <>
                        {
                            (regId === null || regId === undefined) ? 
                                <Alert
                                severity="info"
                                sx={{
                                    alignItems: 'center'
                                }}>
                                    Please create registration before adding payment
                                </Alert>
                            :
                                <Alert
                                    severity="info"
                                    sx={{
                                        alignItems: 'center'
                                    }}
                                >
                                    No payments
                                </Alert>
                        }
                    </>
                )
                : (
                    <Alert
                        severity="info"
                        sx={{
                            alignItems: 'center'
                        }}
                    >
                        No payment needed
                    </Alert>

                )


            }
        </>
    )
}

export default AdminPaymentTable;